import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { useLocation } from 'hooks/router';
import SystemStatusService from 'services/systemStatusService.js';

export default function SystemStatusPageDetails(props) {
    const location = useLocation();
    const id = props.match.params.id;
    const [resultDet, setResultDet] = useState([]);

    useAsyncEffect(async () => {
        const updates = await SystemStatusService.API.getSystemStatusDetails(id);
        setResultDet(updates);
    }, [location]);

    return (
        <div className='row justify-content-md-center'>
            <div className='col-12 col-md-10 col-xl-8'>

            </div>
        </div>
    );
}
